import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingBag, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Logo } from "@/components/Logo";

const links = [
  { to: "/shop", label: "Shop", testid: "nav-shop-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const Header = () => {
  const { count, setCartOpen } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-[#E4E4DE] bg-[#F7F7F2]/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo" className="group" onClick={() => setOpen(false)}>
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.25em] transition-colors ${
                  isActive ? "text-[#4D7C0F]" : "text-zinc-500 hover:text-zinc-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            className="hidden md:block font-mono text-xs uppercase tracking-[0.25em] text-zinc-600 hover:text-[#4D7C0F] transition-colors"
          >
            Admin
          </Link>
          <button
            data-testid="nav-cart-btn"
            onClick={() => setCartOpen(true)}
            className="relative h-11 w-11 flex items-center justify-center border border-[#E4E4DE] text-zinc-700 hover:border-[#C8FF1E] hover:text-[#4D7C0F] transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 h-5 min-w-5 px-1 flex items-center justify-center bg-[#C8FF1E] text-black font-mono text-[10px] font-bold"
              >
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="nav-mobile-menu-btn"
            className="md:hidden h-11 w-11 flex items-center justify-center border border-[#E4E4DE] text-zinc-700"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="md:hidden border-t border-[#E4E4DE] bg-[#F7F7F2] px-4 py-4 flex flex-col gap-4">
          {[...links, { to: "/admin", label: "Admin", testid: "nav-admin-link-mobile" }].map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              onClick={() => setOpen(false)}
              className="font-mono text-sm uppercase tracking-[0.25em] text-zinc-600 hover:text-[#4D7C0F] py-2"
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
